module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"activeSources":"Aktif Kaynaklar","inactiveSources":"Pasif Kaynaklar","addSource":"Kaynak Ekle","dataLoading":"Veri Yükleniyor..."},"en":{"activeSources":"Active Sources","inactiveSources":"Inactive Sources","addSource":"Add Source","dataLoading":"Loading Data..."}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Data/Summary.vue
// module id = cKtT
// module chunks = 1